import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractConcept } from '../../../models/Entities/Contracts/ContractConcept';
import { ContractConceptPaymentSchedule } from '../../../models/Entities/Contracts/ContractConceptPaymentSchedule';

export default function ContractConceptPaymentScheduleReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_ADD_REQUEST_ACTION': {
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
        error: undefined,
      } as ContractState;
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_ADD_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contactAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptPaymentSchedule.contractConceptId);
          if (CurrentConcept) {
            CurrentConcept.paymentSchedule = (CurrentConcept.paymentSchedule || []).concat([a.contractConceptPaymentSchedule]);
            CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
            CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
          }
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        error: undefined,
      };
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_ADD_FAIL_ACTION': {
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error,
      } as ContractState;
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_UPDATE_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
          if (CurrentConcept) {
            let CurrentConceptPaymentSchedule = CurrentConcept.paymentSchedule?.find((item: ContractConceptPaymentSchedule) => item.id === a.contractConceptPaymentSchedule.id);
            if (CurrentConceptPaymentSchedule) {
              CurrentConceptPaymentSchedule = {
                ...CurrentConceptPaymentSchedule,
                isUpdating: true,
                isUpdatedSuccessfully: undefined,
                failOnUpdating: false,
                errorOnUpdating: undefined,
              } as ContractConceptPaymentSchedule;
              CurrentConcept.paymentSchedule = [...(CurrentConcept.paymentSchedule || []).filter((ps: ContractConceptPaymentSchedule) => ps.id !== CurrentConceptPaymentSchedule!.id), CurrentConceptPaymentSchedule];
              CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
              CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
            }
          }
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
        isUpdatingOne: true,
        successUpdatingOne: undefined,
        failOnUpdatingOne: false,
        error: undefined,
      } as ContractState;
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_UPDATE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
          if (CurrentConcept) {
            const updated: ContractConceptPaymentSchedule = {
              ...a.contractConceptPaymentSchedule,
              isUpdatedSuccessfully: true,
            } as ContractConceptPaymentSchedule;
            CurrentConcept.paymentSchedule = [...(CurrentConcept.paymentSchedule || []).filter((item: ContractConceptPaymentSchedule) => item.id !== updated.id), updated];
            CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
            CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
          }
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
        isUpdatingOne: false,
        successUpdatingOne: true,
        failOnUpdatingOne: false,
        error: undefined,
      };
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_UPDATE_FAIL_ACTION': {
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: false,
        failOnUpdatingOne: true,
        error: a.error,
      } as ContractState;
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_GET_ALL_BY_CONTRACTCONCEPTID_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
          if (CurrentConcept) {
            CurrentConcept.paymentSchedule = a.contractConceptPaymentSchedules as ContractConceptPaymentSchedule[];
            CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
            CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
          }
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_UPDATE_ALL_BY_CONTRACTCONCEPTID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (!contract) return currentState;
      const contractConcept = contract.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
      const conceptsFiltered = contract.concepts?.filter((item: ContractConcept) => item.id !== a.contractConceptId) || [];
      const newConcepts = [...conceptsFiltered, { ...contractConcept, paymentSchedule: a.contractConceptPaymentSchedules } as any];
      const newContract = { ...contract, concepts: newConcepts } as Contract;
      return {
        ...currentState,
        list: [...(currentState.list || []).filter((item: Contract) => item.id !== newContract.id), newContract],
      };
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_DELETE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
          if (CurrentConcept) {
            CurrentConcept.paymentSchedule = (CurrentConcept.paymentSchedule || []).filter((item: ContractConceptPaymentSchedule) => item.id !== a.contractConceptPaymentScheduleId);
            CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
            CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
          }
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
        error: undefined,
      };
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_DELETE_REQUEST_ACTION': {
      return {
        ...currentState,
        isDeletingOne: true,
        successDeletingOne: undefined,
        failOnDeletingOne: false,
        error: undefined,
      } as ContractState;
    }
    case 'CONTRACTCONCEPTPAYMENTSCHEDULE_DELETE_FAIL_ACTION': {
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: a.error,
      } as ContractState;
    }
    default:
      return currentState;
  }
}
